import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  DELETE_ALL_ALERTS_ACTION,
  DELETE_ONE_ALERT_ACTION,
  GET_USER_MESSAGES,
} from '../../../actions';
import { Column, Row, Spinner } from '@tempmee/react';
import { borderRadius, shadows } from '@tempmee/tailwind';
import history from '../../../browserHistory';
import useLoading from '../../../hooks/useLoading';
import { EmptyChatIcon } from '../../../images/icons';
import Messages from '../../messages/Messages';
import { EmptyInbox } from '../Empty';
import { useChatsDeletion } from './hooks/useChatsDeletion';
import { useChatsInfiniteScroll } from './hooks/useChatsInfiniteScroll';

export const Chat = ({ isRootComponent }) => {
  const chats = useSelector((state) => state.messages.allJobsWithMessages);
  const dashboardInfo = useSelector((state) => state.job.dashboardInfo);

  const { handleDeleteAll, handleDeleteOneAlertSubmit } = useChatsDeletion();
  const { elRef, getUserMessages, onScrollListener } = useChatsInfiniteScroll();
  const isFinalPage = useSelector((state) => state.messages.isFinalPage);
  const { isLoading } = useLoading([
    GET_USER_MESSAGES,
    DELETE_ALL_ALERTS_ACTION,
    DELETE_ONE_ALERT_ACTION,
  ]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollPosition + windowHeight >= documentHeight) {
        getUserMessages();
      }
    };

    if (isRootComponent) {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isRootComponent, getUserMessages]);

  if (isLoading && chats.length === 0) {
    return (
      <Row align="center" justify="center" style={{ width: '100%', flex: 1, minHeight: 300 }}>
        <Spinner size="md" />
      </Row>
    );
  }

  if (!isLoading && chats.length === 0) {
    return (
      <EmptyInbox
        Icon={EmptyChatIcon}
        title="No chats yet!"
        description={
          <>
            Get started by reaching out to a professional
            <br />
            once they're scheduled for their shift.
          </>
        }
        descriptionStyle={{
          textAlign: 'center',
        }}
      />
    );
  }

  const selectedMessage = (job) => {
    history.push(`/dashboard/chat/${job.id}`, { jobId: job.id });
  };

  return (
    <Column
      ref={elRef}
      onScroll={onScrollListener}
      style={{
        borderRadius: borderRadius.pill,
        boxShadow: shadows['elevation-4'],
        maxHeight: isRootComponent ? undefined : 500,
        overflowY: 'scroll',
        flex: 1,
      }}
    >
      <Messages
        isLoading={isLoading}
        selectedJobs={selectedMessage}
        deleteAll={handleDeleteAll}
        deleteOneAlert={handleDeleteOneAlertSubmit}
      />
      {!isFinalPage && isLoading && <Spinner size="md" />}
    </Column>
  );
};
